import { render } from "./ContactoView.vue?vue&type=template&id=82aab804&scoped=true"
import script from "./ContactoView.vue?vue&type=script&lang=js"
export * from "./ContactoView.vue?vue&type=script&lang=js"

import "./ContactoView.vue?vue&type=style&index=0&id=82aab804&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82aab804"]])

export default __exports__